export const rekvizity = `# Реквизиты

**Колодец и Септики** — строительство колодцев и монтаж септиков

---

## Сведения об исполнителе

| Реквизит | Значение |
|---|---|
| Полное наименование | ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ СЕРЕБРЕННИКОВ РОМАН АЛЕКСАНДРОВИЧ |
| Сокращённое наименование | ИП Серебренников Р.А. |
| ИНН | 752405626175 |
| ОГРНИП | 325508100039277 |
| Юридический адрес | 143512, Россия, Московская обл., г. Истра, д. Адуево, тер. ДНП Дольче Вита, д. 322/1 |
| Сайт | https://kolodec-septiki.ru |
| Электронная почта | info@kolodec-septiki.ru |

---

## Банковские реквизиты

| Реквизит | Значение |
|---|---|
| Расчётный счёт | 40802810500007775572 |
| Банк | АО «ТБанк» |
| ИНН банка | 7710140679 |
| БИК | 044525974 |
| Корреспондентский счёт | 30101810145250000974 |
| Юридический адрес банка | 127287, г. Москва, ул. Хуторская 2-я, д. 38А, стр. 26 |

---

*ИП Серебренников Р.А. применяет упрощённую систему налогообложения (УСН) и не является плательщиком НДС.*
`;
